import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  name: 'resumenec',
  mixins: [mixx],
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,

      f_c: {
        tipo: false,
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
      }
    }
  },
  mounted: function () {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: [],


    });
    $('.box').boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  computed: {
    reporte: function () {
      return (
        "/reportes/resumen/extracash?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta +
        "&tipo=" +
        this.f_c.tipo
      );
    }
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();

      let fl = 0;
      if (this.filtro_li) {
        fl = 1;
        var column2 = this.tbv.column(3)
        column2.visible(false)
        var column1 = this.tbv.column(0)
        column1.visible(false);
      } else {
        fl = 0;
        var column2 = this.tbv.column(3)
        column2.visible(true)
        var column1 = this.tbv.column(0)
        column1.visible(true);
      }



      this.$http
        .post('/reportes/resumen/extracash', this.f_c)
        .then(response => {

          if (response.data.status == 1) {
            for (let i = 0; i < response.data.data.length; i++) {
              response.data.data[i][4] = this.num_to_many(response.data.data[i][4]);
              response.data.data[i][5] = this.num_to_many(response.data.data[i][5]);
              response.data.data[i][6] = this.num_to_many(response.data.data[i][6]);
              this.tbv.row.add(response.data.data[i]);

            }

          }
          this.tbv.draw();

          this.loading = false;
        });

    },

  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/resumenec/index.js